import React, {Component, useRef, useEffect} from 'react';
import {Line} from 'react-chartjs-2';
import Chart from 'chart.js/auto';
var Rainbow = require('rainbowvis.js');

class LittleEndian extends Component{
	constructor(props){
		super(props)
		this.state = {
			text: this.hex(this.props.children)
		}
		this.MouseOver = this.MouseOver.bind(this)
		this.MouseOut = this.MouseOut.bind(this)
	}
	hex(str){
		let hex;
		let result = "";
		let curr = "";
		for(let i =0;i<str.length;i++){
			hex = str.charCodeAt(i).toString(16).toUpperCase()
			curr = hex + curr

			if (i%4 === 3){
				result += curr + " "
				curr = ""
			}
		}
		if(curr.length > 0 && curr.length % 4 !== 0){
			curr = curr.padStart(8, "0")
		}
		result += curr
		return result
	}
	MouseOver(event){
		this.setState((prevState, props) => {
			return {text: props.children}
		})
	}
	MouseOut(event){
		this.setState((prevState, props) => {
			return {text: this.hex(props.children)}
		})
	}
	render(){
		return (
			<span onMouseOver={this.MouseOver} onMouseOut={this.MouseOut}>
				{this.state.text}
			</span>
		)
	}
}

class AsmGraphics extends Component{
	constructor(props){
		super(props)
		this.state = {
			data: Array(0),
			index: 0
		}

		setInterval(function(){
			if(this.state.data.length > 0){
				this.setState((prevState) => {
					return {
						index: (prevState.index + 1) % prevState.data.length
					}
				})
			}
		}.bind(this), 300)
	}

	componentDidMount(){
		fetch("/fermat_asm.txt")
			.then(res => res.text())
			.then(text => {
				this.setState({
					data: text.split('\n')
				})
			})
	}

	render() {
		const range = 10
		let upper = Math.max(this.state.index-(range/2), 0)
		let lower = Math.min(this.state.index+(range/2), this.state.data.length)
		return (
			<pre>
				{
					this.state.data.slice(upper,lower).concat(Array(range-(lower-upper)).fill("\n")).map((line, idx) => {
						if(line.length === 0)
							line = " "
						return(
							<div key={idx}>{line}</div>
						)
					})
				}
			</pre>
		)
	}
}

class TrigGraphic extends Component{
	constructor(props){
		super(props)
		let x = Array(100).fill(1).map((val, idx) => {return val + idx*.1})
		this.state = {
			x: x,
			sin: x.map((val) => {return Math.sin(val)}),
			cos: x.map((val) => {return Math.cos(val)})
		}
		setInterval(function(){
			let next_x = Number(this.state.x.slice(-1))+.1
			this.setState({
				x: this.state.x.slice(1).concat(next_x),
				sin: this.state.sin.slice(1).concat(Math.sin(next_x)),
				cos: this.state.cos.slice(1).concat(Math.cos(next_x)),
			})
		}.bind(this), 100)
	}
	render(){
		return (<pre>
			<div style={{position: "relative",  textAlign:"center"}}>
					<Line ref='chart' height={100}
						data={{
							labels: this.state.x,
							datasets:[
							{
								label: "sin",
								data: this.state.sin,
								backgroundColor: 'rgb(0,255,0)',
								borderColor: 'rgba(0,255,0,.4)',
								fill:false
							},
							{
								label:"cos",
								data: this.state.cos,
								backgroundColor: 'rgb(0,255,255)',
								borderColor: 'rgba(0,255,255,.4)',
								fill:false
							}]	
						}}
						
						options = {{ 
							
							interaction:{enabled:false},
							plugins:{
								legend:{
									display: false
								},
								
							},
							
							scales:{
								xAxes:{
									display:false
								},
								yAxes:{
									display:false,
									ticks:{
										min: -1.25,
										max: 1.25
									}
								}
							},
							responsive:true, 
							maintainAspectRatio: false }} 
						/>
				</div>
		</pre>)
	}
}

class SimAnn extends Component{
	constructor(props){
		super(props)
		this.minX = -2
		this.maxX = 2
		this.minY = -2
		this.maxY = 1
		this.step = .01//.05
		this.state = {
			curr_x: Math.random() * (this.maxX - this.minX) + this.minX,
			curr_y: Math.random() * (this.maxY - this.minY) + this.minY,
			eval_z: undefined,
			best_x: undefined,
			best_y: undefined,
			best_z: undefined,
			step: 1,
			last_change: 1,
			history: {
				xs: [],
				ys: []
			}
		}
		this.temp = 100
		this.alpha=.2
		this.canvas = null
		this.background = null

		// Bind member functions
		this.canvas_coords = this.canvas_coords.bind(this)
		this.update_probe = this.update_probe.bind(this)
		this.reset_view = this.reset_view.bind(this)

		// Precalculate Data points
		this.zs = [];
		this.xs = [];
		this.ys = [];
		for(let x=this.minX; x<=this.maxX; x+=this.step){
			let z = []
			this.xs.push(x)
			for(let y=this.minY; y<=this.maxY; y+=this.step){
				z.push(this.goldsteinPrice(x,y))
				// Run once
				if(x === this.minX)
					this.ys.push(y)
			}
			this.zs.push(z)
		}

		this.rainbow = this.log_scale(this.min_2d(this.zs), this.max_2d(this.zs))
	}

	goldsteinPrice(x, y) {
		return ((1 + Math.pow(x + y + 1, 2) * (19 - 14 * x + 3 * x * x - 14 * y + 6 * x * x + 3 * y * y))
			* (30 + Math.pow(2 * x - 3 * y, 2) * (18 - 32 * x + 12 * x * x + 48 * y - 36 * x * y + 27 * y * y)));
	}

	max_2d(arr){
		return Math.max.apply(null,(arr.map((row)=>{return Math.max.apply(Math, row)})))
	}

	min_2d(arr){
		return Math.min.apply(null,(arr.map((row)=>{return Math.min.apply(Math, row)})))
	}

	log_scale(min, max){
		max = Math.ceil(Math.log10(max))
		min = Math.floor(Math.log10(min))
		let rainbow = new Rainbow();
		rainbow.setNumberRange(min, max)
		rainbow.setSpectrum('cyan', 'green')
		
		return rainbow
	}

	canvas_coords(x, y, ctxt){
		const x_range = this.maxX - this.minX
		const y_range = this.maxY - this.minY
		return {
			c_x: ((x-this.minX)/x_range) * ctxt.canvas.width,
			c_y: ((y-this.minY)/y_range) * ctxt.canvas.height
		}	
	}

	async update_probe(){
		if(this.state.step - this.state.last_change > 35){
			this.reset_view()
		}

		const candidate_x = this.state.curr_x + (Math.random()-.5) * this.alpha
		const candidate_y = this.state.curr_y + (Math.random()-.5) * this.alpha
		const candidate_z = this.goldsteinPrice(candidate_x, candidate_y)

		if (candidate_z < this.state.best_z){
			await this.setState({
				best_x: candidate_x,
				best_y: candidate_y,
				best_z: candidate_z
			})
		}

		const diff = candidate_z - this.state.eval_z
		const metro = Math.exp(-diff / (this.temp / (this.state.step+1)))

		if (diff < 0 || Math.random < metro){
			await this.setState((prev) => {
				return {
					curr_x: candidate_x,
					curr_y: candidate_y,
					eval_z: candidate_z,
					last_change: prev.step,
					history:{
						xs: prev.history.xs.concat(candidate_x),
						ys: prev.history.ys.concat(candidate_y)
					}
				}
			})
		}

		await this.setState((prev) => {
			return {
				step: prev.step + 1
			}
		})

		await new Promise(r => setTimeout(r, 200))
		this.update_probe()		
	}

	async reset_view(){
		const new_x = Math.random() * (this.maxX - this.minX) + this.minX
		const new_y = Math.random() * (this.maxY - this.minY) + this.minY
		await this.setState({
			curr_x: new_x,
			curr_y: new_y,
			eval_z: this.goldsteinPrice(new_x, new_y),
			best_x: new_x,
			best_y: new_y,
			best_z: this.goldsteinPrice(new_x, new_y),
			step: 1,
			last_change: 1,
			history:{
				xs: [new_x],
				ys: [new_y]
			}
		})
	}

	componentDidMount(){
		this.reset_view()
		this.update_probe()
	}

	render(){
		const BgFunction = props => {
			let canvasRef = useRef(null)
			this.background = canvasRef
			useEffect(() => {
				const canvas = canvasRef.current
				const context = canvas.getContext('2d', {alpha: false})
				canvas.width = canvas.parentElement.offsetWidth
				canvas.height = canvas.parentElement.offsetHeight
				const c_width = 2*(this.step/(this.maxX-this.minX))*canvas.width
				const c_height = 2*(this.step/(this.maxY-this.minY))*canvas.height

				// Draw Contours
				for(let i = 0; i < this.xs.length; i++){
					let x = this.xs[i]
					for(let j = 0; j < this.ys.length; j++){
						let y = this.ys[j]
						let z = this.zs[i][j]
						
						let {c_x, c_y} = this.canvas_coords(x, y, context)
						context.fillStyle = '#' + this.rainbow.colourAt(Math.round(Math.log10(z)))
						context.beginPath()
						
						context.fillRect(c_x, c_y, c_width, c_height)
					}
				}
			}, [])

			return (
				<canvas id="bg-function" ref={canvasRef} {...props}/>
			)
		}
		const Canvas = props => {
			let canvasRef = useRef(null)
			this.canvas = canvasRef
			useEffect(() => {
				const canvas = canvasRef.current
				const context = canvas.getContext('2d', {alpha: true})
				canvas.width = canvas.parentElement.offsetWidth
				canvas.height = canvas.parentElement.offsetHeight

				// Draw Historical Exploration Points
				let rainbow = new Rainbow();
				rainbow.setNumberRange(0, this.state.history.xs.length+1)
				rainbow.setSpectrum('white', 'black')
				for(let i=0;i<this.state.history.xs.length; i++){
					context.fillStyle = '#' + rainbow.colourAt(i)
					let {c_x, c_y} = this.canvas_coords(this.state.history.xs[i], this.state.history.ys[i], context)
					context.beginPath()
					context.arc(c_x, c_y, 4, 0, Math.PI*2)
					context.closePath()
					context.fill()
				}

				// Draw Exploration Point
				context.fillStyle = '#000000'
				let {c_x, c_y} = this.canvas_coords(this.state.curr_x, this.state.curr_y, context)
				context.beginPath()
				context.arc(c_x, c_y, 5, 0, Math.PI*2)
				context.closePath()
				context.fill()	

			}, [])
			
			return <canvas id="annealing" ref={canvasRef}  {...props}/>
		}

		// let layout = {
		// 	paper_bgcolor: "#222225",
		// 	showlegend: false,
		// 	margin:{
		// 		autoexpand: false
		// 	},
		// 	textfont:{
		// 		color: "ff3c74"
		// 	}
			
		// }
		
		return (
			<div className="canvas-container">
				<BgFunction/>
				<Canvas />
				<div onClick={this.update_probe}>step</div>
			</div>
		)
	}
}

export {LittleEndian, TrigGraphic, AsmGraphics, SimAnn};
